import { FileType } from 'common/files/files.enums';

export const getFileExtension = (name: string) => {
  const split = name.split('.');

  return split[split.length - 1];
};

export const isEncryptedPdf = async (file: File) => {
  const text = await file.text();

  return file.type === FileType.Pdf && text.includes('Encrypt');
};

export const createFileWithName = (file: File, newName: string) => {
  const fileExtension = getFileExtension(file.name).toLowerCase();

  return new File([file], `${newName}.${fileExtension}`);
};

export const handleFiles = async (files: File[], fileName: string) => {
  return files.map((file: File) => createFileWithName(file, fileName));
};
